<template>
  <div class="add-subscribe">
    <van-notice-bar wrapable :scrollable="false" color="#333">
      <p style="font-size:12px;">订阅后，平台会根据您设置的条件，将符合的职位推送给您。</p>
      <p style="font-size:12px;" v-if="hasData == 2">您还没有任何订阅，请开始第一次订阅吧。</p>
    </van-notice-bar>
    <div class="forms-wrap">
      <div class="forms-cols">
        <van-cell-group>
          <van-field v-model="form.keyword" label="职位名" placeholder="请输入职位名" />

          <van-field
            v-model="area"
            @click="showPickerAddr = true"
            v-if="province"
            clickable
            readonly
            label="城市"
            placeholder="请选择城市"
          >
            <span slot="right-icon">
              <van-icon name="arrow" />
            </span>
          </van-field>
          <van-field
            v-model="functionTitle"
            @click="showPickerFun = true"
            clickable
            readonly
            label="职能"
            placeholder="请选择职能"
          >
            <span slot="right-icon">
              <van-icon name="arrow" />
            </span>
          </van-field>
          <van-field
            v-model="companyKeywords"
            @click="showCompanyPop = true"
            clickable
            readonly
            label="公司"
            placeholder="请输入公司名称"
          >
            <span slot="right-icon">
              <van-icon name="arrow" />
            </span>
          </van-field>
          <van-field
            v-model="salaryRange"
            @click="showPickerSalary = true"
            clickable
            readonly
            label="年薪"
            placeholder="请选择年薪范围"
          >
            <span slot="right-icon">
              <van-icon name="arrow" />
            </span>
          </van-field>
          <!-- <van-field v-model="form.minShowAnnualSalary" label="年薪" placeholder="请输入金额">
            <span slot="right-icon" style="color:#333;">万</span>
          </van-field>-->
          <van-field
            v-model="spaName"
            @click="showPickerSpa = true"
            clickable
            readonly
            label="SPA咨询师"
            placeholder="请选择"
          >
            <span slot="right-icon">
              <van-icon name="arrow" />
            </span>
          </van-field>
          <van-field
            v-model="tagName"
            @click="showPickerTags = true"
            clickable
            readonly
            label="职位标签"
            placeholder="请选择"
          >
            <span slot="right-icon">
              <van-icon name="arrow" />
            </span>
          </van-field>
        </van-cell-group>
      </div>
      <div class="btn">
        <van-button type="primary" @click="submit">确定</van-button>
      </div>
    </div>

    <!-- 地址 -->
    <van-popup v-model="showPickerAddr" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsAddr"
        @cancel="showPickerAddr = false"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
    <!-- 职能 -->
    <van-popup v-model="showPickerFun" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsFun"
        @cancel="showPickerFun = false"
        @confirm="onConfirmFun"
        @change="onChangeFun"
      />
    </van-popup>
    <!-- spa -->
    <van-popup v-model="showPickerSpa" position="bottom">
      <van-picker
        show-toolbar
        value-key="userName"
        :columns="columnsSpa"
        @cancel="showPickerSpa = false"
        @confirm="onConfirmSpa"
      />
    </van-popup>

    <!-- tag -->
    <van-popup v-model="showPickerTags" position="bottom">
      <van-picker
        show-toolbar
        value-key="showName"
        :columns="columnsTags"
        @cancel="showPickerTags = false"
        @confirm="onConfirmTags"
      />
    </van-popup>

    <!-- 薪资 -->
    <van-popup v-model="showPickerSalary" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsSalary"
        @cancel="showPickerSalary = false"
        @confirm="onConfirmSalary"
        @change="onChangeSalary"
      />
    </van-popup>
    <!-- 公司 -->

    <van-popup v-model="showCompanyPop" position="right" :style="{ width:'80%', height:'100%' }" @close="companyClose">
      <div class="search-int">
        <van-search placeholder="请输入公司关键词" v-model="companyKeywords" class="add-companys" @input="searchCompany" />
      </div>
      <div class="search-list" v-show="(list && list.length) || loading">
        <van-loading v-if="loading"/>
        <van-cell-group v-if="!loading">
          <van-cell v-for="item in list" :title="item.name" @click="selectKeyword(item)">
            <template slot="default">
              <van-icon name="search" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>
<style lang="scss" scoped>
.add-subscribe {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f5;
  .forms-wrap {
    // 隐藏最上方1px边框
    margin-top: -1px;
    padding-bottom: 30px;
    .forms-cols {
    }
  }
  .btn {
    .van-button {
      width: 100%;
      font-size: 16px;
    }
    padding: 0 15px;
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.add-subscribe {
  .van-cell-group {
    input {
      font-size: 16px;
    }
  }
  .van-field {
    padding-top: 15px;
    span {
      font-size: 16px;
    }
  }
  .add-companys {
    .van-field {
      padding-top: 5px;
      padding-left: 0px;
    }
  }
}
</style>
<script>
import {
  getPositionTitle,
  matchAssistantOptions,
  subscriptionSave,
  getSuggest
} from "@/api/subscribe";
import { mapState } from "vuex";

// 本页加载 根据 是否有订阅列表 显示添加还是列表
export default {
  name: "add-subscribe-module",
  data() {
    return {
      loading:false,
      hasData:this.$route.query.hasData || 2,
      showPickerAddr: false,
      showPickerFun: false,
      showPickerSpa: false,
      showPickerTags: false,
      showPickerSalary: false,
      showCompanyPop: false,
      province: null,
      citys: null,
      list:[],
      companyKeywords: "",
      curCompanyName:{},
      FunParent: [],
      FunSubs: {},
      columnsAddr: [],
      columnsFun: [],
      columnsSpa: [],
      columnsTags: [],
      columnsSalary: [],
      area: "",
      functionTitle: "",
      spaName: "",
      tagName: "",
      salaryRange: "",
      form: {
        keyword: "",
        cityScope: "",
        functionScope: "",
        enterpriseId: "",
        minShowAnnualSalary: "",
        maxShowAnnualSalary: "",
        spaUserId: "",
        positionTagId: "",
        enterpriseName:""
      }
    };
  },
  computed: {
    ...mapState({
      cities: state => state.comp.cities || {}
    })
  },

  components: {},
  methods: {
    companyClose(){
      if(!this.form.enterpriseId){
        this.companyKeywords = '';
      };
      if(this.companyKeywords != this.curCompanyName){ //关闭的时候不等于 说明没有点
        this.companyKeywords = '';
      };
    },
    selectKeyword(item){
      this.form.enterpriseId = item.id;
      this.companyKeywords = item.name;
      this.curCompanyName = item.name;
      this.showCompanyPop = false;
    },
    searchCompany(){
      getSuggest({
        type: 1,
        limit: 8,
        word: this.companyKeywords,
        nature: 1
      }).then(res => {
          this.list = res.data || [];
      }).catch(err=>{

      });
    },
    onConfirmSalary(values, index) {
      this.salaryRange = values[0].name == values[1].name?values[0].name:values[0].name + "-" + values[1].name;
      this.form.minShowAnnualSalary = values[0].num;
      this.form.maxShowAnnualSalary = values[1].num;
      this.showPickerSalary = false;
    },
    onConfirmTags(values, index) {
      this.tagName = values.name + "-" + values.showMessage;
      this.form.positionTagId = values.code;
      this.showPickerTags = false;
    },
    onConfirmSpa(values, index) {
      this.spaName = values.userName;
      this.form.spaUserId = values.id;
      this.showPickerSpa = false;
    },
    onConfirmFun(values, index) {
      this.form.functionScope = values[1].id;
      this.functionTitle = values[1].name;
      this.showPickerFun = false;
    },
    onChangeSalary(picker, values) {
      let start = values[0].num / 100000;
      let salaryMax = [];
      for (let i = start; i < 21; i++) {
        salaryMax.push({
          num: i * 100000,
          name: (i * 10) + "万"
        });
      }

      picker.setColumnValues(1, salaryMax);
    },
    onChangeFun(picker, values) {
      picker.setColumnValues(1, this.FunSubs[values[0].id]);
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.citys[values[0].id]);
    },
    onConfirm(values, index) {
      this.form.cityScope = values[1].id;
      this.area = values[0].name + " " + values[1].name;
      this.showPickerAddr = false;
    },
    getFunctions() {
      this.FunParent = [];
      this.FunSubs = {};
      getPositionTitle({
        hasPositionTotal: true
      })
        .then(res => {
          let funs = res.data.positionTitleList.splice(0, 5) || [];
          let other = {
            groupId: null,
            id: 999,
            industryId: "",
            isHot: false,
            name: "其他",
            parentId: 0,
            positionTotal: 70,
            type: 0,
            list: [
              { id: 108003, name: "采购/供应链", type: 1 },
              { id: 104001, name: "策划推广", type: 1 },
              { id: 108004, name: "投融资", type: 1 },
              { id: 117005, name: "交互设计", type: 1 },
              { id: 114002, name: "项目管理", type: 1 }
            ]
          };
          funs.push(other);
          funs.forEach(cols => {
            this.FunParent.push({
              id: cols.id,
              name: cols.name
            });
            this.FunSubs[cols.id] = [];
            cols.list.forEach(subs => {
              if (!subs.isHot) {
                this.FunSubs[cols.id].push({
                  id: subs.id,
                  name: subs.name
                });
              }
            });
          });
          this.columnsFun = [
            {
              values: this.FunParent,
              className: "column1"
            },
            {
              values: this.FunSubs[this.FunParent[0].id],
              className: "column2",
              defaultIndex: 0
            }
          ];
        })
        .catch(err => {});
    },
    setCities() {
      this.province = window.METADATA.province;
      this.citys = window.METADATA.areaList.city_list;
      this.columnsAddr = [
        {
          values: this.province,
          className: "column1"
        },
        {
          values: this.citys[this.province[0].id],
          className: "column2",
          defaultIndex: 0
        }
      ];
    },
    submit() {
      // if(!this.form.keyword.trim()){
      //   this.$toast("请填写职位名称");
      //   return;
      // }
      // if(!this.form.cityScope){
      //   this.$toast("请选择城市");
      //   return;
      // }
      // if(!this.form.functionScope){
      //   this.$toast("请选择职能");
      //   return;
      // }
      // if(!this.form.enterpriseId){
      //   this.$toast("请选择公司");
      //   return;
      // }
      // if(!this.form.minShowAnnualSalary.trim()){
      //   this.$toast("请填写年薪");
      //   return;
      // }
      // if(!this.form.spaUserId){
      //   this.$toast("请选择SPA咨询师");
      //   return;
      // }
      // if(!this.form.positionTagId){
      //   this.$toast("请选择职位标签");
      //   return;
      // }
      let isSubmit = false;
      for (let i in this.form) {
        if (this.form[i]) {
          isSubmit = true;
        }
      }

      if (!isSubmit) {
        this.$toast("请添加至少一个条件");
        return;
      }

      if(this.form.enterpriseId){
        this.form.enterpriseName = this.companyKeywords;
      };

      // if(this.form.minShowAnnualSalary){
      //   if(!/^\d+(\.\d+)?$/.test(this.form.minShowAnnualSalary)){
      //     this.$toast("请输入正确的金额");
      //     return;
      //   };
      //   this.form.maxShowAnnualSalary = this.form.minShowAnnualSalary;
      // };
      this.$store.commit("comp/POST_LOADING", true);
      subscriptionSave(this.form)
        .then(res => {
          this.$router.push({ path: "/subscribe" });
        })
        .catch(err => {});
    }
  },
  watch: {
    cities() {
      this.setCities();
    },
    companyKeywords(){
      if(this.companyKeywords == ""){
        this.form.enterpriseId = "";
      }
    }
  },
  created() {
    // 获取职能
    this.getFunctions();
    // 获取SPA咨询师 & 获取职位标签
    matchAssistantOptions()
      .then(res => {
        this.columnsSpa = res.data.paUserViews || [];

        res.data.positionTags.forEach(cols => {
          cols.showName = cols.name + "-" + cols.showMessage;
        });
        this.columnsTags = res.data.positionTags || [];
      })
      .catch(err => {});

    //薪资选择
    let salaryList = [];
    for (let i = 1; i < 21; i++) {
      salaryList.push({
        num: i * 100000,
        name: (i * 10) + "万"
      });
    }

    this.columnsSalary = [
      {
        values: salaryList,
        className: "column1"
      },
      {
        values: salaryList,
        className: "column2",
        defaultIndex: 1
      }
    ];

    if (window.METADATA.areaList) {
      this.setCities();
    }
  }
};
</script>
